import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Zap } from "lucide-react";

const NAV = [
  { id: "services", label: "Capabilities" },
  { id: "process", label: "Process" },
  { id: "stats", label: "Impact" },
  { id: "contact", label: "Contact" },
  { id: "about", label: "About Us" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#F7F5F0]/80 backdrop-blur-2xl border-b border-black/10" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="container-x flex items-center justify-between h-20">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
          data-testid="brand-logo"
        >
          <div className="relative">
            <Zap size={20} className="text-[#C99B1A] fill-[#C99B1A]" strokeWidth={2.5} />
            <div className="absolute inset-0 blur-md bg-[#C99B1A] opacity-40 -z-10" />
          </div>
          <span className="font-display font-bold text-lg tracking-tight text-[#0A0A0A]">
            BARRAQ<span className="text-[#C99B1A]">.</span>AI
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((item) => (
            <button
              key={item.id}
              onClick={() => handleNav(item.id)}
              className="text-xs uppercase tracking-[0.22em] text-black/60 hover:text-[#C99B1A] transition-colors duration-300 font-medium"
              data-testid={`nav-${item.id}`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button
            onClick={() => handleNav("contact")}
            className="btn-primary"
            data-testid="header-cta-button"
          >
            Start Project
          </button>
        </div>

        <button
          className="lg:hidden text-[#0A0A0A]"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-[#F7F5F0] border-t border-black/10 overflow-hidden"
            data-testid="mobile-menu"
          >
            <div className="container-x py-8 flex flex-col gap-6">
              {NAV.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleNav(item.id)}
                  className="text-left font-display text-2xl text-[#0A0A0A] hover:text-[#C99B1A] transition-colors"
                  data-testid={`mobile-nav-${item.id}`}
                >
                  {item.label}
                </button>
              ))}
              <button onClick={() => handleNav("contact")} className="btn-primary mt-4 self-start">
                Start Project
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
